<template>
  <a-modal
      title="选择短剧"
      :visible="visible"
      width="900px"
      :footer="null"
      @cancel="$emit('close')"
      :maskClosable="false"
  >
    <a-form layout="inline" :model="searchForm" style="margin-bottom: 16px;">
      <a-form-item label="短剧ID">
        <a-input v-model="searchForm.id" allow-clear />
      </a-form-item>
      <a-form-item label="短剧名称">
        <a-input v-model="searchForm.videoName" allow-clear />
      </a-form-item>
      <a-form-item label="短剧标签">
        <a-select v-model="searchForm.type" allow-clear style="width: 120px">
          <a-select-option :value="''">全部</a-select-option>
          <a-select-option :value="0">无</a-select-option>
          <a-select-option :value="1">new</a-select-option>
          <a-select-option :value="2">hot</a-select-option>
          <a-select-option :value="3">首播</a-select-option>
          <a-select-option :value="4">独播</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="短剧分类">
        <a-select v-model="searchForm.tagIdList" mode="multiple" allow-clear style="min-width: 200px">
          <a-select-option v-for="tag in tagList" :key="tag.id" :value="tag.id">{{ tag.tagTitle }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-button type="primary" @click="loadList">搜索</a-button>
      <a-button @click="reset">重置</a-button>
    </a-form>

    <a-table
        rowKey="id"
        :data-source="data"
        :columns="columns"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        @rowClick="handleRowClick"
    >
      <template slot="coverUrl" slot-scope="text, record">
        <img :src="record.coverUrl" width="60" height="80" />
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'VideoSelector',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      searchForm: {
        id: '',
        videoName: '',
        type: '',
        tagIdList: []
      },
      data: [],
      pagination: { current: 1, pageSize: 10, total: 0 },
      tagList: [],
      columns: [
        { title: '短剧ID', dataIndex: 'id', width: 100 },
        { title: '短剧名称', dataIndex: 'videoName' },
        {
          title: '封面',
          dataIndex: 'coverUrl',
          scopedSlots: { customRender: 'coverUrl' }, // 插槽名
          width: 100
        },
        {
          title: '标签',
          dataIndex: 'type',
          width: 80,
          customRender: val => ['无', 'new', 'hot', '首播', '独播'][val] || ''
        },
        { title: '分类', dataIndex: 'tagIds' }
      ]
    }
  },
  methods: {
    loadList() {
      this.loading = true
      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.searchForm
      }
      request.get('/video/videos/page', { params }).then(res => {
        this.data = res.data?.records || []
        this.pagination.total = res.data?.total || 0
        this.loading = false
      })
    },
    loadTags() {
      request.get('/video/video-tags/page', {params: {pageNum: 1, pageSize: 100}}).then(res => {
        this.tagList = res.data?.records || []
      })
    },
    reset() {
      this.searchForm = {id: '', videoName: '', type: '', tagIdList: []}
      this.pagination.current = 1
      this.loadList()
    },
    handleTableChange(pager) {
      this.pagination.current = pager.current
      this.loadList()
    },
    handleRowClick(record) {
      this.$emit('select', record)
    }
  },
  mounted() {
    this.loadTags()
    this.loadList()
  }
}
</script>

<style scoped>
</style>
